import React, { Component } from 'react';
import {AppBar, Toolbar, Typography, Paper, CardContent, TextField, CardActions, Button, CircularProgress, List, ListItem, ListItemIcon} from '@material-ui/core';

class LoginContainer extends Component {
    render() {
        return <React.Fragment>
              <CardContent>
                <Typography variant="headline">Sign Up</Typography>
                <div id="fields">
                  <TextField id="username" label="Email" type="email" />
                  <TextField id="pw" label="Password" type="password" />
                </div>
              </CardContent>
              <CardActions>
                <Button variant="contained" color="primary" onClick={this.props.done}>Sign Up</Button>
              </CardActions>
            </React.Fragment>;
    }
}

export default LoginContainer;